import Vue from 'vue'
import {
    findModuleIndex,
    modulesReferToSameModule,
    removeByIndices,
} from '@/shared/utils/moduleUtils'

function getParentModuleId(module) {
    return (
        module.module_id ||
        (module.module && module.module.id) ||
        module.id
    )
}

function comboDefinitionRef(definitionItem) {
    const moduleId =
        definitionItem.id != null && definitionItem.id !== ''
            ? definitionItem.id
            : definitionItem.module_id

    return {
        module_id: moduleId,
        module: {
            id: moduleId,
            external_id:
                definitionItem.module_id || definitionItem.external_id,
        },
    }
}

function findComboItemIndex(comboItems, definitionItem) {
    const ref = comboDefinitionRef(definitionItem)

    return comboItems.findIndex(item => modulesReferToSameModule(item, ref))
}

function addParentReference(comboModule, parentModuleId) {
    if (!comboModule._comboParentIds) {
        Vue.set(comboModule, '_comboParentIds', [])
    }

    if (!comboModule._comboParentIds.includes(parentModuleId)) {
        comboModule._comboParentIds.push(parentModuleId)
    }
}

function removeParentReference(comboModule, parentModuleId) {
    if (!comboModule._comboParentIds) {
        return true
    }

    comboModule._comboParentIds = comboModule._comboParentIds.filter(
        id => id !== parentModuleId,
    )

    return comboModule._comboParentIds.length === 0
}

/**
 * Evita duplicar linhas de combo quando dois pais compartilham o mesmo item.
 */
export function showParentComboOptions({
    parentModule,
    comboItems,
    planPackageId,
    optionalModulesLength,
    createComboModules,
}) {
    if (!parentModule.combo || !parentModule.combo.length) {
        return
    }

    const parentModuleId = getParentModuleId(parentModule)
    const createdModules = createComboModules(
        parentModule,
        planPackageId,
        optionalModulesLength,
    )

    parentModule.combo.forEach(definitionItem => {
        const ref = comboDefinitionRef(definitionItem)
        const comboModule = createdModules.find(created =>
            modulesReferToSameModule(created, ref),
        )

        if (!comboModule) {
            return
        }

        const existingIndex = findComboItemIndex(comboItems, definitionItem)

        if (existingIndex !== -1) {
            addParentReference(comboItems[existingIndex], parentModuleId)
            return
        }

        addParentReference(comboModule, parentModuleId)
        comboItems.push(comboModule)
    })
}

export function hideParentComboOptions({
    parentModule,
    comboItems,
    proposalModules,
}) {
    if (!parentModule.combo || !parentModule.combo.length) {
        return
    }

    const parentModuleId = getParentModuleId(parentModule)
    const comboIndicesToRemove = []
    const proposalIndicesToRemove = []

    parentModule.combo.forEach(definitionItem => {
        const comboIndex = findComboItemIndex(comboItems, definitionItem)

        if (comboIndex === -1) {
            return
        }

        const shouldRemoveRow = removeParentReference(
            comboItems[comboIndex],
            parentModuleId,
        )

        if (!shouldRemoveRow) {
            return
        }

        comboIndicesToRemove.push(comboIndex)

        const proposalIndex = findModuleIndex(
            proposalModules,
            comboDefinitionRef(definitionItem),
        )

        if (proposalIndex !== -1) {
            proposalIndicesToRemove.push(proposalIndex)
        }
    })

    removeByIndices(comboItems, comboIndicesToRemove)
    removeByIndices(proposalModules, [...new Set(proposalIndicesToRemove)])
}
